import { Variables } from 'react-relay';
import { MockResponseConfig } from '../getMockResponse';

export const mockNonExistentUser: MockResponseConfig = {
  UnifiedProfileQuery: (variables: Variables) => ({
    data: {
      unified: {
        unifiedProfile: {
          __typename: 'UnifiedQueryError',
          identifier: 'nonexistent',
          message:
            'ACCOUNTS_FETCH_BY_UNIFIED_PROFILE_USERNAME_FAILED, Unable to fetch profile',
          extensions: [
            {
              errorType: 'INTERNAL_SERVER_ERROR',
              statusCode: 500,
            },
          ],
        },
      },
    },
  }),
};
